<template>
    <div class="loading-overlay" v-bind:class="{ active: pending.load_single_note }">
        <div class="square">
            <loader-basic-spinner class="blue large" />
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import LoaderBasicSpinner from "loaders/BasicSpinner";

    export default {
        name: "SingleNoteLoading",
        computed: {
            ...mapState("note", ["pending"])
        },
        components: {
            LoaderBasicSpinner
        }
    }
</script>

<style scoped>
    .loading-overlay {
        position: absolute;
        visibility: hidden;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: 10;
        z-index: 10;
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        filter: alpha(opacity=0);
        opacity: 0;

        -webkit-transition: opacity 0.4s ease, visibility 0.4s ease;
        -moz-transition: opacity 0.4s ease, visibility 0.4s ease;
        -ms-transition: opacity 0.4s ease, visibility 0.4s ease;
        -o-transition: opacity 0.4s ease, visibility 0.4s ease;
        transition: opacity 0.4s ease, visibility 0.4s ease;
    }
    .loading-overlay.active {
        visibility: visible;
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
        filter: alpha(opacity=100);
        opacity: 1;
    }
    .square {
        position: relative;
        background: #fff;
        border-radius: 3px;
        top: 50%;
        left: 50%;
        width: 96px;
        height: 96px;
        margin-left: -48px;
        margin-top: -48px;
        padding: 16px;
        z-index: 11;
    }
</style>